import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { cloneDeep, orderBy } from 'lodash';
import { Company, Category } from '../shared/models/v-builder.models';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { Modalconfig } from '../../shared/constants';
import { VBuilderCategoryModalComponent } from './v-builder-category-modal/v-builder-category-modal.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-v-builder-category-list',
    templateUrl: './v-builder-category-list.component.html',
    styleUrls: ['./v-builder-category-list.component.scss'],
    standalone: false
})
export class VBuilderCategoryListComponent implements OnInit, OnDestroy {

  modalRef: BsModalRef;
  companies: Company[];
  vBuilderCategories: Category[];
  modalSubscription: Subscription;
  devicePixelRatio = devicePixelRatio;
  constructor(
    private router: Router,
    private modalService: BsModalService,
    private commonHttpService: CommonHttpService
  ) { }

  ngOnInit() {
    this.getAllCategories();
    this.getCompanies();
    this.setModalChanges();
  }

  /**
   * To fetch all the categories
   */
  getAllCategories() {
    this.commonHttpService.get<Category[]>(
      {
        uri: '/api/VBuilder/GetAllCategories'
      }).subscribe((response) => {
        this.vBuilderCategories = response;
      });
  }
  

  /**
   * To fetch all the companies
   */
  getCompanies() {
    this.commonHttpService.get<Company[]>(
      {
        uri: '/api/Companies'
      }).subscribe((response) => {
        this.companies = orderBy(response, ['name']);
      });
  }

  /**
   * To reflect added, updated or deleted category changes from categoryModal component
   */
  setModalChanges() {
    this.modalSubscription = this.modalService.onHide
      .subscribe(() => {
        if (this.modalRef && this.modalRef.content) {
          if (this.modalRef.content.addedCategory
            || this.modalRef.content.editedCategory
            || this.modalRef.content.deletedCgId) {
            // refresh the categories list after add/edit/delete
            this.getAllCategories();
          }
        }
      });
  }

  /**
   * To initialize category modal with appropriate category values
   */
  openCategoryModal(verb: string, category: Category) {
    const initialState = {
      verb,
      companyList: this.companies,
      selectedCategory: cloneDeep(category) || new Category()
    };
    this.modalRef = this.modalService.show(VBuilderCategoryModalComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
  }

  /**
   * To navigate to category detail page
   */
  goToCategoryDetail(category: Category) {
    this.router.navigate([`vbuilder/category/detail/${category.id}`]);
  }

  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }
}
